// src/components/universal-features/breadcrumbs.jsx
import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const CustomBreadcrumbs = ({ breadcrumbItems }) => {
    const navigate = useNavigate();

    return (
        <Breadcrumbs 
            separator={<NavigateNextIcon fontSize="small" />} 
            aria-label="breadcrumb"
            sx={{ mb: 2 }}
        >
            {breadcrumbItems.map((item, index) => {
                const isLast = index === breadcrumbItems.length - 1;
                
                if (isLast || item.isActive) {
                    return (
                        <Typography key={index} color="text.primary">
                            {item.label}
                        </Typography>
                    );
                }
                
                return (
                    <Link
                        key={index}
                        underline="hover"
                        color="inherit"
                        href={item.href}
                        onClick={(e) => {
                            e.preventDefault();
                            if (item.href) {
                                navigate(item.href);
                            }
                        }}
                        sx={{ 
                            display: 'flex', 
                            alignItems: 'center',
                            cursor: 'pointer'
                        }}
                    >
                        {index === 0 && <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />}
                        {item.label}
                    </Link>
                );
            })}
        </Breadcrumbs>
    );
};

export default CustomBreadcrumbs;